import { Input } from "antd";
import { bool, object } from "prop-types";
import { useIntl } from "react-intl";
import { DynamicFormItem } from "./DynamicFormItem";
import { getPlaceholderText } from "./helper/getPlaceholderText";
import { useCheckEditableFormField } from "./hooks/useCheckEditableFormField";

const { TextArea } = Input;

export const DynamicTextArea = ({
  formField,
  formField: {
    property,
    property: { maxCharacterLength, name },
  },
  formDisabled,
}) => {
  const intl = useIntl();
  const { isDisabled } = useCheckEditableFormField(formField);

  const characterLengthProps =
    maxCharacterLength > 0
      ? { maxLength: maxCharacterLength, showCount: true }
      : {};

  return (
    <DynamicFormItem formFieldProperty={property}>
      <TextArea
        data-test-id={`dynamic-text-area-${name}`}
        rows={4}
        disabled={formDisabled || isDisabled}
        placeholder={getPlaceholderText(formDisabled, formField, intl)}
        {...characterLengthProps}
      />
    </DynamicFormItem>
  );
};

DynamicTextArea.propTypes = {
  formField: object.isRequired,
  formDisabled: bool,
};
